import React from "react";

import { LANGUAGES, useLanguage } from "../contexts/LanguageContext";

/** ҚАЗ / РУС ауыстырғышы — `ThemeSwitch`-тің қасында тұрады. */
const LanguageSwitch = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="inline-flex rounded-lg overflow-hidden border border-gray-600">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
          className={`px-2 py-1 text-[11px] font-semibold transition-colors ${
            language === code
              ? "bg-accent-grad text-white"
              : "text-text-secondary hover:text-white"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
